import type { NetworkLocales } from '@/types/lang/locales'

export const networkEn: NetworkLocales = {
    api: {
        error: {
            fetchNetworks: 'Error while fetching networks',
            fetchPendingInvites: 'Error while fetching pending invitations',
            fetchReceivedInvites: 'Error while fetching received invitations',
            sendNetworkInvite: 'Error while sending network invitation',
            fetchInvite: 'Error while fetching the invitation',
            declineNetworkInvite: 'Error while declining network invite',
            validateNetworkInvite: 'Error while validating network invite',
            deleteNetwork: 'Error while deleting network'
        },
        success: {
            fetchNetworks: 'Networks successfully fetched !',
            fetchPendingInvites: 'Pending invitations successfully fetched !',
            fetchReceivedInvites: 'Received invitations successfully fetched !',
            sendNetworkInvite: 'Invitations successfully sent !',
            fetchInvite: 'Invite successfully fetched !',
            declineNetworkInvite: 'Invitation declined',
            validateNetworkInvite: 'Invitation validated',
            deleteNetwork: 'Network successfully deleted'
        }
    }
}
